import { NotificationTypes, SafeAny } from '@/common/types';
import { getCookie, getIdToken, getTokenPrefix } from '@/common/utils';

function getAuthHeaders(authToken?: string | null): Record<string, string> {
  if (!authToken) {
    const environment = getTokenPrefix();
    const eventsApiKey = getCookie(`${environment}-eventsApiKey`);

    return {
      'x-user-auth': getCookie('automated-test-auth-token') ?? '',
      'x-api-key': eventsApiKey ?? ''
    };
  }

  return { 'x-user-auth': authToken };
}

export const deleteClaim = async (
  { rootState, commit }: SafeAny,
  sleepStudyID: NonNullable<string>
): Promise<void> => {
  const url = `${rootState.env?.requestUrl.events}/studies/${sleepStudyID}/claim`;
  const authToken = await getIdToken();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...getAuthHeaders(authToken)
  };

  try {
    fetch(url, {
      method: 'DELETE',
      headers,
      keepalive: true
    });
  } catch (error: SafeAny) {
    commit(
      'addNotification',
      {
        i18nTitle: 'errorUpdateUser',
        i18nDescription: error.message,
        type: NotificationTypes.Error
      },
      { root: true }
    );
  }
};
